module.exports = __webpack_public_path__ + "img/wancheng_bg.826bd30c.png";